module.exports = __webpack_public_path__ + "img/icircle.3a187418.svg";